import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { connectLean } from 'lean-redux';
import { withRouter } from 'react-router';
import { compose, withApollo } from 'react-apollo';
import { merge, isEmpty, forEach } from 'lodash';
import { Icon } from 'legacy-packages/ft-cb';

import {
  shareUnit,
  unshareResources,
} from 'legacy/packages/unit-outline/src/queries';
import UnitWrapper from './UnitWrapper';
import UnitPreview from './UnitPreview';
import { ItemAction } from '../ItemAction';
import log from 'chameleon/ui-stack/utilities/log';

import './Unit.scss';

class Unit extends Component {
  static displayName = 'Unit';

  static propTypes = {
    params: PropTypes.object,
    item: PropTypes.object,
    expand: PropTypes.bool,
    onExpanderClick: PropTypes.func,
  };

  constructor(props) {
    super(props);

    const { item } = props;

    this.state = {
      item,
    };

    this.saveAction = this.saveAction.bind(this);
    this.clearResourcesSavedClasses =
      this.clearResourcesSavedClasses.bind(this);
  }

  componentDidMount() {
    const { params, item } = this.props;
    const { unitId } = params;
    const expand = unitId === item.id;
    if (expand) {
      const body = document.documentElement;
      const bodyRect = body.getBoundingClientRect();
      const node = ReactDOM.findDOMNode(this);
      const nodeRect = node.getBoundingClientRect();
      const offset = nodeRect.top - bodyRect.top;
      body.scrollTop = offset - window.innerHeight / 2;
    }
  }

  /**
   * Saves unit sharing selected classes
   * @param {array} selectedItems The selected classes
   * */
  saveAction(selectedItems) {
    const { params, item } = this.props;

    this.props.client
      .mutate({
        mutation: shareUnit,
        variables: {
          subject: params.subject,
          unitId: item.id,
          classIds: selectedItems,
        },
      })
      .then(() => {
        /**
         * If selected items is empty array, clear saved classes
         * */
        const hasSelectedItems = selectedItems.length;
        if (!hasSelectedItems) {
          this.clearResourcesSavedClasses();
        }
        this.props.setItemsAllowActions(hasSelectedItems);
      })
      .catch((error) => log('error', error));
  }

  /**
   * Clear resources saved classes from store
   * */
  clearResourcesSavedClasses() {
    let resourcesIds = [];
    const { item, sharedResources, subject } = this.props;
    (item.subunits || []).forEach((subunit) => {
      (subunit.resources || []).forEach((resource) => {
        const sharedResource =
          sharedResources[`resource-${resource.id}-subject-${subject.id}`];
        /**
         * Find all resources that are shared
         * */
        if (
          resource.isShareable &&
          !isEmpty(sharedResource) &&
          (sharedResource.savedClasses || []).length
        ) {
          resourcesIds.push(resource.id);
        }
      });
    });

    if (resourcesIds.length) {
      /**
       * Clear shared resources from store
       * */
      this.props.clearSharedResources();
      /**
       * Unshare resources from backend
       * */
      this.props.client
        .mutate({
          mutation: unshareResources,
          variables: {
            subject: this.props.params.subject,
            ids: resourcesIds,
          },
        })
        .catch((error) => log('error', error));
    }
  }

  render() {
    const { item, expand, onExpanderClick } = this.props;
    const isOpenClass = expand ? 'is-open' : '';

    const stateLabels = {
      active: 'Visible',
      inactive: 'Not Visible',
    };

    return (
      <UnitWrapper
        title={
          <a onClick={onExpanderClick}>
            <span className={`icon ${isOpenClass}`}>
              <Icon name="circle_with_triangle" width="20" height="20" />
            </span>
            <label>
              {item.displayName}: {item.title}
            </label>
          </a>
        }
        preview={<UnitPreview expand={expand} unit={item} />}
      >
        <ItemAction
          stateLabels={stateLabels}
          item={item}
          save={this.saveAction}
          scope={['units', `unit-${item.id}`]}
        />
      </UnitWrapper>
    );
  }
}

function mapStateToProps(state) {
  const { userData } = state;

  return {
    userData,
  };
}

export default compose(
  withRouter,
  withApollo,
  connect(mapStateToProps),
  connectLean({
    /**
     * Nested Array Scope
     * */
    scope: (props) => ['units', `unit-${props.item.id}`, 'resources'],
    mapState(state) {
      return {
        sharedResources: state,
      };
    },
    /**
     * Clear all resource saved classes
     * */
    clearSharedResources() {
      this.setState((prevState) => {
        let resources = {
          ...prevState,
        };
        forEach(resources, (resource, key) => {
          if (resource.savedClasses || resource.selectedItems) {
            resources[key] = {
              disabled: resource.disabled,
              selectedItems: [],
              savedClasses: [],
            };
          }
        });

        return merge(prevState, resources);
      });
    },
    /**
     * Enable/Disable resources actions
     * Saving if resource is disabled to each resource store
     * */
    setItemsAllowActions(hasSelectedItems) {
      const disabled = !hasSelectedItems;
      let allResources = {};
      const { item, subject } = this.props;
      (item.subunits || []).forEach((subunit) => {
        (subunit.resources || []).forEach((resource) => {
          allResources[`resource-${resource.id}-subject-${subject.id}`] = {
            disabled,
          };
        });
      });

      if (!isEmpty(allResources)) {
        this.setState((prevState) =>
          /**
           * Update all resources under a unit level even if no stores exists at this point
           * */
          merge(prevState, allResources),
        );
      }
    },
  }),
)(Unit);
